import React from 'react'

import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import { Modal, ModalClose, ModalContent } from '@mc/design-system'
import { VideoAutoplay, VideoOverlay } from '@mc/video'

import { EndScreen } from 'pages/sessions/shared/EndScreen'
import { VideoPlayer } from 'components/VideoPlayer'

import { getVideoPlayerEventAttributes } from './events'

const CampHeroTrailerModal = ({
  show,
  onClose,
  videoId,
  mediaUuid,
  contentId,
  contentTitle,
  slug,
  isLive,
}: CampHeroTrailerModalProps) => (
  <div data-testid='camp-hero-trailer-modal'>
    <Modal backdrop='extra-dark' show={show} onClose={onClose}>
      <ModalClose />
      <ModalContent>
        <VideoPlayer
          contentId={contentId}
          contentTitle={contentTitle}
          contentType={TRACK_CONTENT_TYPES.CAMP_TRAILER}
          videoId={videoId}
          mediaUuid={mediaUuid}
          extraTrackingParams={getVideoPlayerEventAttributes(
            slug,
            isLive,
            contentId,
          )}
        >
          <VideoAutoplay />
          <VideoOverlay state={['paused', 'ended']} fade>
            <EndScreen pageType='class-page' />
          </VideoOverlay>
        </VideoPlayer>
      </ModalContent>
    </Modal>
  </div>
)

type CampHeroTrailerModalProps = {
  show: boolean
  onClose(): void
  videoId?: string
  mediaUuid: string | undefined
  contentId: string
  contentTitle: string
  slug: string
  isLive: boolean
}

export default CampHeroTrailerModal
